import { Icons } from "assets/icons";
import FilterBar from "components/common/FilterBar";
import NoDataFound from "components/common/NoDataFound";
import Paginations from "components/common/Paginations";
import { StatusBadge } from "components/common/StatusBadge";
import DataTable from "components/common/table/DataTable";
import { usePermission } from "hooks/usePermission";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { formatUTCDate } from "utils/utils";


const KioskActivity = () => {
  const { t } = useTranslation();

  return (
    <div className="page-content addons_page">
      <h4 className="page_title mb-3">{t("POS Activity")}</h4>
    </div>
  );
};

export default KioskActivity;